import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type InviteAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.InviteAccountConnectionInput;
}>;

export type InviteAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  inviteAccountConnection?: GraphQLTypes.Maybe<
    { __typename?: 'InviteAccountConnectionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const InviteAccountConnectionDocument = /*#__PURE__*/ gql`
  mutation inviteAccountConnection($input: InviteAccountConnectionInput!) {
    inviteAccountConnection(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useInviteAccountConnectionMutation__
 *
 * To run a mutation, you first call `useInviteAccountConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteAccountConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteAccountConnectionMutation, { data, loading, error }] = useInviteAccountConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteAccountConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<InviteAccountConnectionMutationResult, InviteAccountConnectionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<InviteAccountConnectionMutationResult, InviteAccountConnectionMutationVariables>(
    InviteAccountConnectionDocument,
    options
  );
}
export type InviteAccountConnectionMutationHookResult = ReturnType<typeof useInviteAccountConnectionMutation>;
